// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToolkitsFilters_wrapper__9Q9gx","title":"ToolkitsFilters_title__2nCbD","controls":"ToolkitsFilters_controls__ok4Bz","placeholder":"ToolkitsFilters_placeholder__BPiEB"};